import React from 'react'
import styled, { css } from 'styled-components'

import { FontStyle, Text } from '.'
import { dimensions, spacing } from '../../constants/theme'

type AlertType = 'warning' | 'success' | 'primary' | 'neutral'

interface StyledAlertProps {
  type: AlertType
}

const StyledAlert = styled.div<StyledAlertProps>`
  width: 100%;
  display: flex;
  border-radius: ${dimensions.borderRadiusSM};
  padding: ${spacing.spacingLG};
  align-items: center;
  flex-shrink: 0;
  margin: ${spacing.spacingMD} 0;
  ${({ type }) => {
    if (type === 'warning') {
      return css`
        & > p {
          color: var(--chakra-colors-red-solid);
        }
        background-color: var(--chakra-colors-red-subtle);
        border: 1px solid var(--chakra-colors-red-emphasized);
        border-left: 4px solid var(--chakra-colors-red-emphasized);
      `
    }
    if (type === 'success') {
      return css`
        & > p {
          color: var(--chakra-colors-green-solid);
        }
        background-color: var(--chakra-colors-green-subtle);
        border: 1px solid var(--chakra-colors-green-emphasized);
        border-left: 4px solid var(--chakra-colors-green-emphasized);
      `
    }
    if (type === 'primary') {
      return css`
        & > p {
          color: var(--chakra-colors-brand-solid);
        }
        background-color: var(--chakra-colors-brand-subtle);
        border: 1px solid var(--chakra-colors-brand-emphasized);
        border-left: 4px solid var(--chakra-colors-brand-emphasized);
      `
    }
    if (type === 'neutral') {
      return css`
        & > p {
          color: var(--chakra-colors-fg-default);
        }
        background-color: var(--chakra-colors-bg-muted);
        border: 1px solid var(--chakra-colors-border-default);
        border-left: 4px solid var(--chakra-colors-border-default);
      `
    }
  }}
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 8px;
`

export interface AlertProps {
  children?: string
  icon?: React.ReactNode
  type?: AlertType
}

const Alert: React.FC<AlertProps> = ({
  children = 'This is alert text, how neat!',
  icon,
  type = 'warning',
}) => {
  return (
    <StyledAlert type={type}>
      {icon && <IconWrapper>{icon}</IconWrapper>}
      <Text size={FontStyle.bSmall} text={children} />
    </StyledAlert>
  )
}

export { Alert }
